export const LOYALTY_LANDING_PAGE = 'societe'
export const LOYALTY_OFFERS_HUB_PAGE = 'societe/offers'
export const LOYALTY_TERMS_AND_CONDITIONS_PAGE = 'societe-terms-and-conditions'
export const TASTE_OF_GOLD_DETAILS_PAGE = 'societe/taste-of-gold/details'
export const ESIM_DETAILS_PAGE = 'societe/esim/details'
export const ESIM_INFO_PAGE = 'societe/esim/info'
export const TIER_PROGRESSION_DETAILS_PAGE = 'societe/tier-progression/:highestTier'
export const TIER_UPGRADE_CAMPAIGN_PAGE = 'societe/:campaignSlug'
export const LOUNGE_PASSES_PAGE = 'societe/benefits/lounge-passes'
export const LOYALTY_PURCHASE_POINTS_PAGE = 'societe/buy-points'
export const LOYALTY_REWARDS_PAGE = 'societe/rewards-seats-maldives'
